import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import {useConnect} from '@lore/query-connect';
import useDialogConfig from '../_hooks/useDialogConfig';
import RedirectConnectDialog from '../../dialogs/redirect.connect';
import usePageRouter from '../_hooks/usePageRouter';
import useIntents from '../../hooks/useIntents';
import { replaceDialog } from '../_hooks/launch';
import { DialogManager } from '../../dialogs_new/DialogManager';

Launcher.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default function Launcher(props) {
  const config = useDialogConfig();
  const {isEducator} = useIntents();
  const {history} = usePageRouter();
  const navigate = useNavigate();

  const user = useConnect('user.byId', {
    id: config.params.userId
  });

  // projects go through the selector so the user picks an active site before
  // the project is created; it replaces this dialog in place rather than
  // closing it first, since launching during the close transition leaves the
  // dialog stack unresponsive
  function openSelector() {
    replaceDialog(config.id, DialogManager.SelectorProjectEventOffer.Config(), navigate);
  }

  function goToOffer() {
    props.onClose();
    history.push('/post-offer');
  }

  return (
    <RedirectConnectDialog
      user={user}
      onCancel={props.onClose}
      onSubmit={function (kind) {
        if (kind === 'offer') {
          goToOffer();
        } else if (kind === 'project') {
          openSelector();
        } else if (isEducator) {
          openSelector();
        } else {
          goToOffer();
        }
      }}
    />
  );
};
